import { render, staticRenderFns } from "./UnitIconField.vue?vue&type=template&id=24195c60&scoped=true&"
import script from "./UnitIconField.vue?vue&type=script&lang=js&"
export * from "./UnitIconField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24195c60",
  null
  
)

export default component.exports